import {
  asBoolean,
  asDate,
  asNumber,
  asString,
  isObject,
} from "./model-utils";
import { enumValue, CheckInMode } from "./enums";

export class CheckedInBy {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.name = asString(json.name);
  }

  static fromJson(json: any) {
    return isObject(json) ? new CheckedInBy(json) : json;
  }
}

export class EventBundle {
  [key: string]: any;
  constructor(json: any = {}) {
    Object.assign(this, json);
    this.bundleId = asString(json._id || json.bundleId);
    this.name = asString(json.name);
    this.amount = asNumber(json.amount) ?? 0;
    this.ticketSold = asNumber(json.ticketSold) ?? 0;
    this.quantity = asNumber(json.quantity) ?? 0;
    this.number = asNumber(json.number) ?? 1;
    this.ticketNo = asString(json.ticketNo);
    this.barCodeUrl = asString(json.barCodeUrl);
    this.checkIn = asBoolean(json.checkIn) ?? false;
    this.checkInDate = asDate(json.checkInDate);
    this.purchaseDate = asDate(json.purchaseDate);
    this.salesEndDate = asDate(json.salesEndDate);
    this.status = asString(json.status);
    this.currency = asString(json.currency);
    this.checkInMethod = enumValue(CheckInMode, json.checkInMethod);
    this.checkInBy = CheckedInBy.fromJson(json.checkInBy);
    this.paidBundle = asBoolean(json.paidBundle) ?? false;
  }

  get isPaid() {
    return this.paidBundle === true;
  }

  get isCheckedIn() {
    return this.checkIn === true;
  }

  get isAvailable() {
    return (this.quantity || 0) > (this.ticketSold || 0);
  }

  get availableQuantity() {
    return (this.quantity || 0) - (this.ticketSold || 0);
  }

  get totalAmount() {
    return (this.number || 0) * (this.amount || 0);
  }

  static fromJson(json: any) {
    return isObject(json) ? new EventBundle(json) : json;
  }
}
